import React, { useState } from "react";
import { Button, Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import PercentSharpIcon from "@mui/icons-material/PercentSharp";
// import AddIcon from "@mui/icons-material/Add";

// import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import printIcon from "../../../assets/Images/printIcon.svg";

import { useEffect } from "react";
import swal from "sweetalert";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";

// For Tab
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// End

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
// End

import latefees from "../../../assets/Images/latefees.png";
import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";

import CsvDownloader from "react-csv-downloader";
import newSocietylogo from "../../../assets/Images/newSocietylogo.svg";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import Zoom from "react-medium-image-zoom";

import html2pdf from "html2pdf.js";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CreateInvoiceNewList() {
  // const [age, setAge] = React.useState("Open Tickets");

  const navigate = useNavigate();
  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );
  // For Tab
  const [value, setValue] = React.useState(0);

  const [misc_invoiceList, setMisc_InvoiceList] = React.useState([]);
  const [monthly_InvoiceList, setMonthlyInvoiceList] = React.useState([]);

  const [q, setQ] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [paid_note, setPaidNote] = React.useState("");
  const [isPaid, setIsPaid] = React.useState();
  const [invoiceType, setInvoiceType] = React.useState("Monthly Maintenance");
  const [Upload, setUpload] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);

  const [selectedApart, setselectedApart] = useState([]);
  const [selectedResident, setselectedResident] = useState([]);
  const [selectedInvoice, setselectedInvoice] = useState([]);

  const [selectedApartmentIds, setSelectedApartmentIds] = useState([]);
  const [selectedResidentIds, setSelectedResidentIds] = useState([]);
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);

  const [, setCCEmailId] = React.useState("");

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(100);
  const [totalItems, setTotalItems] = React.useState(0);

  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [csvdataarray, setforcsv] = React.useState([]);

  const [unpaidCount, setUnpaidCount] = useState();
  const [paidCount, setPaidCount] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [open2, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [notesList, setNotesList] = React.useState([]);
  
  const handleChange = (event, newValue) => {
    // alert(newValue)
    setValue(newValue);

    // added new change by me
    setSelectedApartmentIds([]);
    setSelectedResidentIds([]);
    setselectedApart([]);
    setselectedResident([]);
    setselectedInvoice([]);
    setSelectedInvoiceIds([]);
    setIsSelectAllChecked(false);
  };
  // End

  // For memu

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    setStatus(status);
    setUpload(!Upload);
    setAnchorEl(null);
    setCurrentPage(1) // added by me for filter with pagination issue
    // InvoiceListing();
  };

  const handleAll = () => {
    setStatus("");
    setUpload(!Upload);
    setAnchorEl(null);
    // InvoiceListing();
  };
  // End

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
    setSelectedApartmentIds([]);
    setSelectedResidentIds([]);
    setselectedApart([]);
    setselectedResident([]);
    setselectedInvoice([]);
    setSelectedInvoiceIds([]);
    setIsSelectAllChecked(false);
  };

  const saveArray = [];
  let obj;

  async function InvoiceListing() {

    const now = new Date();
 
    const fyStartYear = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    const fromDate = `${fyStartYear}-04-01`;
    const toDate = `${fyStartYear + 1}-03-31`;
 
    setShowLoader(true);
    let bodyFormData = {
      searchq: q,
      // pageNo: 1,
      status: status,
      invoice_type: invoiceType,
      pageNo: currentPage,
      count: itemsPerPage,
      fromDate: fromDate,
      toDate: toDate,
    };

    await makePostRequest("invoice/invoicelisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.rows;
          // const paidInvoicesCount = data.filter(
          //   (invoice) => invoice.is_paid
          // ).length;
          // const unpaidInvoicesCount = data.length - paidInvoicesCount;
          setPaidCount(response.data.data.paid_count);
          setUnpaidCount(response.data.data.unpaid_count);
          // added new change by me for excel
          for (let i = 0; i < response.data.data.rows.length; i++) {
            obj = {};
            obj["invoice_id"] = response.data.data.rows[i].invoice_id;
            obj["invoice_date"] = response.data.data.rows[i].invoice_date;
            obj["subject"] = response.data.data.rows[i].subject;
            obj["invoice_note"] = response.data.data.rows[i].invoice_note;
            obj["due_date"] = response.data.data.rows[i].due_date;
            obj["invoice_type"] = response.data.data.rows[i].invoice_type;
            obj["maintenance_total"] =
              response.data.data.rows[i].maintenance_total;

            obj["total_payment"] = response.data.data.rows[i].total_payment;
            obj["advance_received"] =
              response.data.data.rows[i].advance_received;

            obj["past_due"] = response.data.data.rows[i].past_due;
            obj["late_fee"] = response.data.data.rows[i].late_fee;
            obj["is_paid"] = response.data.data.rows[i].is_paid;
            obj["paid_date"] = response.data.data.rows[i].paid_date;
            obj["paid_note"] = response.data.data.rows[i].paid_note;

            saveArray.push(obj);
          }
          setforcsv(saveArray);
          if (invoiceType === "Miscellaneous") {
            setTotalItems(response.data.data.total_records);
            setMisc_InvoiceList(data);
            setShowLoader(false);
          } else {
            setTotalItems(response.data.data.total_records);
            setMonthlyInvoiceList(data);

            setShowLoader(false);

            // console.log("first",response.data.data.total_records)
          }
        } else {
          swal("There was an error!", response.message, "warning");
          setShowLoader(false);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
  }

  async function handleChangeTabs(invoiceType) {
    setInvoiceType(invoiceType);
    setQ("");
    setSelectedResidentoption("");

    // InvoiceListing();
    // setUpload(!Upload);
  }

  function ParseNumberFloat(val1, val2) {
    let total = val1 - val2;
    return parseFloat(total).toFixed(2);
  }

  useEffect(() => {
    InvoiceListing();
    notesListing();
    if (currentPage) {
      residentlisting();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, Upload, currentPage, invoiceType]);

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);
  // For Modal
 

  const handleClickOpen = (scrollType, opt, flg) => () => {
    if (flg === "add") {
      localStorage.setItem("paidInvoiceId", opt.invoice_id);

      setIsPaid(opt.is_paid);
      setOpen(true);
      setScroll(scrollType);
      setPaidNote("");
    } else {
      localStorage.setItem("paidInvoiceId", opt.invoice_id);
      // localStorage.setItem('isPaid',isPaid);
      setIsPaid(opt.is_paid);
      setOpen(true);
      setScroll(scrollType);
      setPaidNote(opt.paid_note);
    }
  };

  const handleClose2 = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  async function paidInvoice() {
    if (paid_note !== "" && paid_note !== undefined) {
      let inputdata;
      let bodyformData = {};
      let invoiceId = localStorage.getItem("paidInvoiceId");
      await makeGetRequest("invoice/getbyid/" + invoiceId, "")
        .then((response) => {
          if (response.data.data !== undefined) {
            inputdata = response.data.data;
            console.log("first", inputdata);
          }
        })
        .catch((err) => {
          console.log("first", err)
          swal("There was an error!", "more error details", "warning");
        });

      if (inputdata.is_paid) bodyformData.is_paid = false;
      else {
        bodyformData.is_paid = true;
        bodyformData.paid_date = new Date();
      }
      bodyformData.paid_note = paid_note;
      bodyformData.note_added_time = new Date();
      bodyformData.invoice_id = inputdata.invoice_id;

      console.log(">>> fcm", inputdata.fcm_token);
      // return;
      await makePostRequest("invoice/update", bodyformData)
        .then((response) => {
          if (response.data.data !== undefined) {

            // added by me for send paid invoice email
            if (!inputdata.is_paid) {
              sendpaidemail(
                inputdata.resident_id,
                inputdata.apartment_id,
                inputdata.invoice_id,
                bodyformData.paid_date
              );

              // for notification

              let fcmToken = inputdata.fcm_token;
              // var jsonObj = { val: "Paid Invoice" };

              var jsonObj = {
                invoice_id: inputdata.invoice_id.toString(),
                monthname: moment(inputdata.invoice_date).format("MMMM-YYYY"),
                invoice_type: inputdata.invoice_type,
              };

              if (fcmToken && fcmToken.trim() !== "" && fcmToken.length > 0) {
                let bodyFormData = {
                  title: "Paid Invoice Email Received",
                  message: "Paid Invoice Email Received",
                  firebaseToken: fcmToken,
                  extraData: jsonObj
                };

                makePostRequest("guards/sendNotification", bodyFormData)
                  .then((response) => {
                    // swal("Success", "Events created successfully", "success", {
                    //   timer: 1000,
                    //   buttons: false,
                    // });
                    InvoiceListing();
                  })
                  .catch((err) => {
                    console.log("notifi", err)
                    swal(
                      "There was an error in sending Notification!!",
                      "more error details",
                      "warning"
                    );
                  });
              } else {
                swal("Can not send notification,as FCM token not avaiable");
                InvoiceListing();
              }
            }
            // swal("Success", "Invoice Paid Successully....", "success", {
            //   timer: 1000,
            //   buttons: false,
            // });
            InvoiceListing();
            var element = document.getElementById("successfullAdd");
            element.classList.toggle("hideModal");
          }
        })
        .catch((err) => {
          console.log("111", err)
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      swal("warning!", "please add note", "warning");
    }
  }







  // for print show changes

  function printAllInvoices(divName) {
    var printContents = document.getElementById(divName).innerHTML;
    // var printWindow = window.open('', '_blank');
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;

    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  }

  function convertDate(date) {
    let arr = date.split("T");
    return arr[0];
  }

  function calcTotalPayment(total_payment, advance_received) {
    let calculatedTot =
      parseFloat(total_payment) - parseFloat(advance_received);
    let calculated_Total = calculatedTot.toFixed(2);
    // convertToIndianWords(calculated_Total)
    return calculated_Total;
  }



  function convertToIndianWords(total_payment, advance_received) {
    let calculatedTot =
      parseFloat(total_payment) - parseFloat(advance_received);
    let calculated_Total = calculatedTot.toFixed(2);
    var a = [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ];
    var b = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];

    function inWords(num) {
      if ((num = num.toString()).length > 9) return "overflow";
      let n = ("000000000" + num)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      var str = "";
      str +=
        n[1] !== 0
          ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
          : "";
      str +=
        n[2] !== 0
          ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
          : "";
      str +=
        n[3] !== 0
          ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
          : "";
      str +=
        n[4] !== 0
          ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
          : "";
      // str +=
      //   n[5] != 0
      //     ? (str != "" ? "and " : "") +
      //       (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
      //       "only "
      //     : "";
      str +=
        n[5] !== 0
          ? (str !== "" ? "and " : "") +
          (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
          ""
          : "";
      return str;
    }

    function convertAmountToWords(calculated_Total) {
      let wholePart = Math.floor(calculated_Total);
      const decimalPart = Math.round((calculated_Total - wholePart) * 100);
      const decimalWords =
        decimalPart > 0 ? "and " + inWords(decimalPart) + "paise" : "";

      if (wholePart === 0) {
        return "zero rupees " + decimalWords + " only";
      }

      const wholeWords = inWords(wholePart);
      return wholeWords + "rupees " + decimalWords + " only";
    }

    return convertAmountToWords(calculated_Total);
  }



  async function notesListing() {
    let bodyFormData = {};

    makeGetRequest("notes/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Notes details Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setNotesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleUserCheckboxChange = (
    aprtId,
    resident_id,
    invoice_id,
    isChecked
  ) => {
    const newSelectedApartid = [...selectedApart];
    const newSelectedResid = [...selectedResident];
    const newSelectedInvoiceid = [...selectedInvoice];
    if (isChecked) {
      newSelectedInvoiceid.push(invoice_id);
      newSelectedApartid.push(aprtId);
      newSelectedResid.push(resident_id);
    } else {
      newSelectedInvoiceid.splice(newSelectedInvoiceid.indexOf(invoice_id), 1);
      newSelectedApartid.splice(newSelectedApartid.indexOf(aprtId), 1);
      newSelectedResid.splice(newSelectedResid.indexOf(resident_id), 1);
    }
    setselectedApart(newSelectedApartid);
    setselectedResident(newSelectedResid);
    setSelectedApartmentIds(newSelectedApartid);
    setSelectedResidentIds(newSelectedResid);
    setselectedInvoice(newSelectedInvoiceid);
    setSelectedInvoiceIds(newSelectedInvoiceid);
    console.log("aprt", newSelectedApartid);
    console.log("resi", newSelectedResid);
    console.log("inv", newSelectedInvoiceid);
  };

  const handleSelectAllChange = (e, type) => {
    const isChecked = e.target.checked;

    // const invoiceList = monthly ? monthly_InvoiceList : misch ? misc_invoiceList : [];

    let invoiceList = [];
    if (type === "monthly") {
      invoiceList = monthly_InvoiceList;
    } else if (type === "misch") {
      invoiceList = misc_invoiceList;
    }

    setselectedApart(
      isChecked ? invoiceList.map((user) => user.apartment_id) : []
    );
    setselectedResident(
      isChecked ? invoiceList.map((user) => user.resident_id) : []
    );
    setselectedInvoice(
      isChecked ? invoiceList.map((user) => user.invoice_id) : []
    );
    let aparmentarr = isChecked
      ? invoiceList.map((user) => user.apartment_id)
      : [];
    let residentarr = isChecked
      ? invoiceList.map((user) => user.resident_id)
      : [];
    let invarr = isChecked ? invoiceList.map((user) => user.invoice_id) : [];
    console.log("appppp", aparmentarr);
    console.log("rrres", residentarr);
    console.log("inv", invarr);
    setSelectedApartmentIds(aparmentarr);
    setSelectedResidentIds(residentarr);
    setSelectedInvoiceIds(invarr);
    setIsSelectAllChecked(isChecked);
  };


  // archiveInvoice
  // const archiveInvoice = async () => {
  //   console.log("in func", selectedInvoiceIds);
  //   if (selectedInvoiceIds.length === 0) {
  //     swal("Warning", "Please select at least one invoice", "warning");
  //     return;
  //   }


  //   try {
  //     setShowLoader(true);

  //     for (let i = 0; i < selectedInvoiceIds.length; i++) {
    
  //       const invoiceId = selectedInvoiceIds[i];

  //       const response = await updateInvoice(
  //         invoiceId
  //       );
  //     }

  //     swal("Success", "Invoice Archived Successully.", "success", {
  //       timer: 1000,
  //       buttons: false,
  //     });
  //     setShowLoader(false);
  //     // Reset selections
  //     setSelectedApartmentIds([]);
  //     setSelectedResidentIds([]);
  //     setselectedApart([]);
  //     setselectedResident([]);
  //     setselectedInvoice([]);
  //     setSelectedInvoiceIds([]);
  //     setIsSelectAllChecked(false);

  //   } catch (error) {
  //     setShowLoader(false);
  //     console.error(`Error archive invoice`, error);
  //     swal("There was an error!", "more error details", "warning");
  //   }

  // }

  // update changes not complete

  // async function updateInvoice() {
  //     // e.preventDefault();
  
  //     var inputdata = "";
  
  //     inputdata = {
    
  //       updated_at: "",
  //     };
  
  //     await makePostRequest("/update", inputdata)
  //       .then((response) => {
  //         if (response.data.status === "1") {
  //           swal("Success", " updated successfully", "success", {
  //             timer: 1000,
  //             buttons: false,
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         swal("There was an error!", "more error details", "warning");
  //       });

  //   }
  
  const createEmail = async () => {
    console.log("in func", selectedApartmentIds);
    if (selectedInvoiceIds.length === 0) {
      swal("Warning", "Please select at least one resident", "warning");
      return;
    }
    // if (selectedApartmentIds.length !== selectedResidentIds.length) {
    //   swal(
    //     "Warning",
    //     "Mismatch between apartment IDs and resident IDs",
    //     "warning"
    //   );
    //   return;
    // }
    try {
      setShowLoader(true);

      for (let i = 0; i < selectedInvoiceIds.length; i++) {
        const apartmentId = selectedApartmentIds[i];
        const residentId = selectedResidentIds[i];
        const invoiceId = selectedInvoiceIds[i];

        // const previewresData = await getInvoicePreview(invoiceId);

        const response = await sendInvoiceEmail(
          residentId,
          apartmentId,
          invoiceId
        );
        console.log(response)
      }

      swal("Success", "Invoice Mail Sent Successully.", "success", {
        timer: 1000,
        buttons: false,
      });
      setShowLoader(false);
      // Reset selections
      setSelectedApartmentIds([]);
      setSelectedResidentIds([]);
      setselectedApart([]);
      setselectedResident([]);
      setselectedInvoice([]);
      setSelectedInvoiceIds([]);
      setIsSelectAllChecked(false);
      // navigate("/InvoiceListing");
    } catch (error) {
      setShowLoader(false);
      console.error(`Error creating invoice`, error);
      swal("There was an error!", "more error details", "warning");
    }
  };

  // const sendInvoiceEmail =async (residentId,apartmentId,invoiceId) =>{}
  const sendInvoiceEmail = async (residentId, apartmentId, invoiceId) => {
    console.log("send");
    // let emailsubject;

    // if (sub === "send email") {
    //   emailsubject =
    //     "Invoice For the Month of " +
    //     moment(invoiceData.invoice_date).format("MMMM");
    // } else {
    //   emailsubject = "Invoice Paid";
    // }
    let sendEmailToTenant = false;
    let isTenantOccupied = false;
    let ccEmail = "";
    let maintenenceList = [];
    let unpaidinvoiceList = [];
    let bankDetailsData = [];

    await makeGetRequest(
      "resident/gettenantbyresidentandapartmentid/" +
      residentId +
      "/" +
      apartmentId
    )
      .then((response) => {
        if (response.status === 201) {
          // setlength(response.data.data.rowCount);
          // const data = response.data.data;
          console.log("Resident response ");
          console.log(response.data.data);
          if (response.data.data !== undefined) {
            isTenantOccupied = true;
            setCCEmailId(response.data.data.user_obj.email_id);
            ccEmail = response.data.data.user_obj.email_id;
          } else {
            isTenantOccupied = false;
            setCCEmailId("");
            ccEmail = "";
          }
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });

    if (isTenantOccupied) {
      // const willDelete = await swal({
      //   title: "This Apartment is Tenant Allocated?",
      //   text: "Do you want to want to send invoice email to tenant also.",
      //   buttons: ["No", "Yes"],
      // });

      // if (willDelete) {
      // sendEmailToTenant = true;
      sendEmailToTenant = false;
      console.log(sendEmailToTenant)

      // }
      // else
      // {
      //   sendEmailToTenant=false;
      // }
    }

    let societyName = localStorage.getItem("societyName");
    let societyAddress = localStorage.getItem("societyAddress");
    let name = "";
    let invoiceDate;
    let dueDate;
    let totalPayable;
    let invoiceData = "";
    let emailbillDate;
    let emaildueDate;
    let emailId;
    await makeGetRequest("invoice/getinvoicepreviewweb/" + invoiceId)
      .then((response) => {
        console.log("Invoice Data ", response);
        invoiceData = response.data.data;
        name =
          invoiceData.user_obj.first_name +
          " " +
          invoiceData.user_obj.last_name;
        invoiceDate = moment(invoiceData.invoice_date).format("DD-MM-YYYY");
        dueDate = moment(invoiceData.due_date).format("DD-MM-YYYY");
        totalPayable = invoiceData.total_payment - invoiceData.advance_received;

        //new
        emailbillDate = moment(invoiceData.invoice_date).format("DD-MM-YYYY");
        emaildueDate = moment(invoiceData.due_date).format("DD-MM-YYYY");
        maintenenceList = invoiceData.maintenence_json_list;
        unpaidinvoiceList = invoiceData.unpaid_invoice;

        // let calculatedTot =
        //   parseFloat(invoiceData.total_payment) -
        //   parseFloat(invoiceData.advance_received);

        bankDetailsData = invoiceData.bank_details;
        emailId = invoiceData.user_obj.email_id;
        console.log(invoiceDate,dueDate)
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });

    let societynumber = localStorage.getItem("societyContactNo");
    let societyEmail = localStorage.getItem("societyEmail");
    let invoiceHtml4;
    let invoiceHtml5;
    let invoiceHtml6;
    let invoiceHtml7;

    if (invoiceType === "Monthly Maintenance") {
      invoiceHtml4 =
        '<!doctype html><html><head><meta charset="utf-8"><title>Email</title><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><meta name="viewport" content="width=device-width, initial-scale=1"></head><body><div style="width: 100%; max-width: 650px; background-color: #fff; margin: 50px auto; border: 1px solid #ccc;border-radius: 10px;overflow: hidden;font-family:\'Poppins\', sans-serif; font-size: 13px;"><div style="background: #f4f3f9; text-align: center;color: #fff;   font-family:\'Poppins\', sans-serif; font-weight: 700;font-size: 28px; letter-spacing: 1px;padding: 20px;box-sizing: border-box;float: left;width: 100%;"><img src="https://suprawebservices.com/Imageskailas/newSocietyLogo.png" alt="logo" style="width: 100%; max-width: 150px;" /></div><div style=" padding: 30px 30px 0px;box-sizing: border-box;"><div style="width: 100%;float: left;text-align: center; padding-top: 25px;"><img src="https://freepngimg.com/save/64685-box-icons-symbol-computer-address-email-gmail/1600x1600" style="width: 100%; max-width: 150px;"/></div><p style="width: 100%; float: left; margin-bottom: 12px; margin-top: 10px;  font-weight: 600; color: #111111; font-size: 28px;text-align: center;">' +
        invoiceData.invoice_type +
        ' Invoice</p>    <div style=" font-weight: 400; margin-top: 0; color: #444444; font-size: 17px;text-align: center;line-height: 22px; margin-bottom: 15px;"> <b style="color: green; font-weight: 600;">' +
        societyName +
        '</b> <div style="font-size: 13px; display: block; margin-top: 10px;"><span>' +
        societyAddress +
        "</span><br><span>Phone : " +
        societynumber +
        ' </span></div></div>  <div style=" float:left; width:100%; font-size: 13px;color: #444444; margin: 30px 0 25px;"><div style="float:left;"><span style="display: block; color: #111111; font-size:13px; font-weight: 500;"></span><span style="display: block;"> Invoice To : <span>' +
        name +
        '</span>  </span><span style="display: block;"> Invoice No : <span>' +
        invoiceData.invoice_id +
        '</span>  </span><span style="display: block;"> Invoice Date: <span>' +
        emailbillDate +
        '</span>  </span><span style="display: block;"> Due Date: <span>' +
        emaildueDate +



        // for new changes 24-7-24

        '</span>  </span></div> <div style="float:right;"> <div style="text-align: right;"><span style="display: block;"> Billing Period : <span>' +
        emailbillDate +
        " to " +
        emaildueDate +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Wing / Flat No : <span>' +
        invoiceData.uniq_apt_name +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Phone : <span>' +
        invoiceData.user_obj.contact_no +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Email : <span>' +
        emailId +
        //end
        "</span> </span></div></div></div>";

      const arrayDataItems = maintenenceList
        .map((option, index) =>
          option.key
            ? option.total || option.total === 0
              ? '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;"></td><td style="text-align: left; padding: 5px 10px;">' +
              option.key +
              " (" +
              option.value +
              '%)</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
              : '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;">' +
              parseInt(index + 1) +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.key +
              '</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.value).toFixed(2) +
              "</td></tr>"
            : null
        )
        .join(" ");

      let arrayunpaidList = "";

      if (unpaidinvoiceList !== null) {
        arrayunpaidList = unpaidinvoiceList
          .map(
            (optionval, index) =>
              "<tr><td>" +
              optionval.invoice_id +
              "</td><td>" +
              optionval.subject +
              "</td><td>" +
              optionval.invoice_date +
              "</td><td>" +
              optionval.due_date +
              "</td><td>₹" +
              parseFloat(optionval.total_payment).toFixed(2) +
              "</td><td>₹" +
              parseFloat(optionval.advance_received).toFixed(2) +
              "</td><td>₹" +
              parseFloat(
                optionval.total_payment - optionval.advance_received
              ).toFixed(2) +
              "</td></tr>"
          )
          .join(" ");
      }

      invoiceHtml5 =
        '<div><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Sr.No</th><th style="text-align: left; padding: 8px 10px;">Description</th><th style="text-align: right; padding: 8px 10px; width: 60px;">Amount</th></tr></thead><tbody>' +
        arrayDataItems +
        "</tbody></table></div>";

      invoiceHtml6 =
        '<div style="text-align: right; margin-bottom: 5px;">Advance Received<b style="width: 85px; display: inline-block">₹' +
        parseFloat(invoiceData.advance_received).toFixed(2) +
        '</b></div><div style="text-align: right; margin-bottom: 5px;">Current Invoice Total<b style="width: 85px; display: inline-block">₹' +
        parseFloat(totalPayable).toFixed(2) +
        '</b></div><div style="color: green; background-color:rgb(192, 255, 192) ; padding: 13px 20px; border-radius: 5px; font-weight: bold; text-align: center; margin: 15px 0 30px;">₹ ' +
        convertToIndianWords(
          invoiceData.total_payment,
          invoiceData.advance_received
        ).toUpperCase() +
        '</div><div><p style="margin: 0 0 10px;"><b>Use Digital payment method for Payments.</b></p><p style="margin: 0 0 10px;"><b>Notes:-</b></p><ul style="  padding-left: 14px;list-style-type: decimal;">' +
        (invoiceData.invoice_note &&
          '<li style="margin: 0 0 10px;">' +
          invoiceData.invoice_note +
          "</li>") +
        notesList
          .map(
            (option, index) =>
              '<li style="margin: 0 0 10px;">' + option.notes + "</li>"
          )
          .join(" ") +
        '</ul><p style="margin: 0 0 15px;"><b>PLEASE NOTE BANK DETAILS BELOW.</b></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Account:</b></span><span>' +
        bankDetailsData.account_holder +
        '</span></p> <p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Bank:</b></span><span>' +
        bankDetailsData.bank_name +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">IFSC Code:</b></span><span>' +
        bankDetailsData.ifsc_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">MICR Code:</b></span><span>' +
        bankDetailsData.micr_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Account No.:</b></span><span>' +
        bankDetailsData.account_no +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Type of Account:</b></span><span>' +
        bankDetailsData.account_type +
        '</span></p><p style="margin: 0 0 20px; display: flex;"><span><b style="width: 150px; display: inline-block;">Bank Address:</b></span><span>' +
        bankDetailsData.address +
        "</span></p>";

      invoiceHtml7 =
        ' <p style="margin: 0 0 30px;">Please inform the online (NEFT/IMPS/UPI) / direct CHEQUE / CASH deposit details (Flat no, Transaction date, Reference no, Account holder name, Amount) by email to ' +
        societyEmail +
        ". Receipt Issue & Account Updating will be done after money transfer confirmation to society bank account.</p>" +
        (unpaidinvoiceList !== null
          ? '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div><p style="margin: 0 0 15px; padding-top: 30px; "><b>Open Invoices:</b></p><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Invoice No.	</th><th style="text-align: left; padding: 8px 10px;">Account </th><th style="text-align: right; padding: 8px 10px; ">Invoice Date </th><th style="text-align: left; padding: 8px 10px;">Due Date	</th><th style="text-align: left; padding: 8px 10px;">Invoice Amount </th><th style="text-align: left; padding: 8px 10px;">Amount Paid </th><th style="text-align: left; padding: 8px 10px;">Amount Due</th></tr></thead><tbody>' +
          arrayunpaidList +
          '</tbody></table><div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>'
          : '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>') +
        '<p style="margin: 0 0 20px;">A Simple Interest of ' +
        invoiceData.late_fee +
        '% per month will be applied against your Unit for all Payments, against Relevant Invoices, after due date.</p><p style="margin: 0 0 20px;">Note: You are receiving this email because you are the "Primary Contact" for your Unit. If you want to change the "Primary Contact" go to My Profile page and choose the desired registered user of your Unit.</p></div></div></div></body></html>';
    } else {
      // for misch
      invoiceHtml4 =
        '<!doctype html><html><head><meta charset="utf-8"><title>Email</title><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><meta name="viewport" content="width=device-width, initial-scale=1"></head><body><div style="width: 100%; max-width: 650px; background-color: #fff; margin: 50px auto; border: 1px solid #ccc;border-radius: 10px;overflow: hidden;font-family:\'Poppins\', sans-serif; font-size: 13px;"><div style="background: #f4f3f9; text-align: center;color: #fff;   font-family:\'Poppins\', sans-serif; font-weight: 700;font-size: 28px; letter-spacing: 1px;padding: 20px;box-sizing: border-box;float: left;width: 100%;"><img src="https://suprawebservices.com/Imageskailas/newSocietyLogo.png" alt="logo" style="width: 100%; max-width: 150px;" /></div><div style=" padding: 30px 30px 0px;box-sizing: border-box;"><div style="width: 100%;float: left;text-align: center; padding-top: 25px;"><img src="https://freepngimg.com/save/64685-box-icons-symbol-computer-address-email-gmail/1600x1600" style="width: 100%; max-width: 150px;"/></div><p style="width: 100%; float: left; margin-bottom: 12px; margin-top: 10px;  font-weight: 600; color: #111111; font-size: 28px;text-align: center;">' +
        invoiceData.invoice_type +
        ' Invoice</p>    <div style=" font-weight: 400; margin-top: 0; color: #444444; font-size: 17px;text-align: center;line-height: 22px; margin-bottom: 15px;"> <b style="color: green; font-weight: 600;">' +
        societyName +
        '</b> <div style="font-size: 13px; display: block; margin-top: 10px;"><span>' +
        societyAddress +
        "</span><br><span>Phone : " +
        societynumber +
        ' </span></div></div>  <div style=" float:left; width:100%; font-size: 13px;color: #444444; margin: 30px 0 25px;"><div style="float:left;"><span style="display: block; color: #111111; font-size:13px; font-weight: 500;"></span><span style="display: block;"> Invoice To : <span>' +
        name +
        '</span>  </span><span style="display: block;"> Invoice No : <span>' +
        invoiceData.invoice_id +
        '</span>  </span><span style="display: block;"> Invoice Date: <span>' +
        emailbillDate +
        '</span>  </span><span style="display: block;"> Due Date: <span>' +
        emaildueDate +



        // for new changes 24-7-24

        '</span>  </span></div> <div style="float:right;"> <div style="text-align: right;"><span style="display: block;"> Billing Period : <span>' +
        emailbillDate +
        " to " +
        emaildueDate +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Wing / Flat No : <span>' +
        invoiceData.uniq_apt_name +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Phone : <span>' +
        invoiceData.user_obj.contact_no +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Email : <span>' +
        emailId +
        //end
        "</span> </span></div></div></div>";

      const arrayDataItems = maintenenceList
        .map((option, index) =>
          option.name
            ? option.name === "CGST" ||
              option.name === "SGST" ||
              option.name === "Late Fee"
              ? '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;"></td><td style="text-align: left; padding: 5px 10px;" colspan="3">' +
              option.name +
              " (" +
              option.amount +
              '%)</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
              : '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;">' +
              parseInt(index + 1) +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.name +
              '</td><td style="text-align:left; padding: 5px 10px;">₹' +
              option.amount +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.duration +
              " " +
              option.duration_key +
              '</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
            : null
        )
        .join(" ");


      let arrayunpaidList = "";

      if (unpaidinvoiceList !== null) {
        arrayunpaidList = unpaidinvoiceList
          .map(
            (optionval, index) =>
              "<tr><td>" +
              optionval.invoice_id +
              "</td><td>" +
              optionval.subject +
              "</td><td>" +
              optionval.invoice_date +
              "</td><td>" +
              optionval.due_date +
              "</td><td>₹" +
              parseFloat(optionval.total_payment).toFixed(2) +
              "</td><td>₹" +
              parseFloat(optionval.advance_received).toFixed(2) +
              "</td><td>₹" +
              parseFloat(
                optionval.total_payment - optionval.advance_received
              ).toFixed(2) +
              "</td></tr>"
          )
          .join(" ");
      }
      console.log(arrayunpaidList)

      invoiceHtml5 =
        '<div><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Sr.No</th><th style="text-align: left; padding: 8px 10px;">Description</th><th style="text-align: left; padding: 8px 10px;">Rate</th><th style="text-align: left; padding: 8px 10px;">Duration</th><th style="text-align: right; padding: 8px 10px; width: 60px;">Amount</th></tr></thead><tbody>' +
        arrayDataItems +
        "</tbody></table></div>";

      invoiceHtml6 =
        '<div style="text-align: right; margin-bottom: 5px;">Advance Received<b style="width: 85px; display: inline-block">₹' +
        parseFloat(invoiceData.advance_received).toFixed(2) +
        '</b></div><div style="text-align: right; margin-bottom: 5px;">Current Invoice Total<b style="width: 85px; display: inline-block">₹' +
        parseFloat(totalPayable).toFixed(2) +
        '</b></div><div style="color: green; background-color:rgb(192, 255, 192) ; padding: 13px 20px; border-radius: 5px; font-weight: bold; text-align: center; margin: 15px 0 30px;">₹ ' +
        convertToIndianWords(
          invoiceData.total_payment,
          invoiceData.advance_received
        ).toUpperCase() +
        '</div><div><p style="margin: 0 0 10px;"><b>Use Digital payment method for Payments.</b></p><p style="margin: 0 0 10px;"><b>Notes:-</b></p><ul style="  padding-left: 14px;list-style-type: decimal;">' +
        (invoiceData.invoice_note &&
          '<li style="margin: 0 0 10px;">' +
          invoiceData.invoice_note +
          "</li>") +
        notesList
          .map(
            (option, index) =>
              '<li style="margin: 0 0 10px;">' + option.notes + "</li>"
          )
          .join(" ") +
        '</ul><p style="margin: 0 0 15px;"><b>PLEASE NOTE BANK DETAILS BELOW.</b></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Account:</b></span><span>' +
        bankDetailsData.account_holder +
        '</span></p> <p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Bank:</b></span><span>' +
        bankDetailsData.bank_name +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">IFSC Code:</b></span><span>' +
        bankDetailsData.ifsc_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">MICR Code:</b></span><span>' +
        bankDetailsData.micr_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Account No.:</b></span><span>' +
        bankDetailsData.account_no +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Type of Account:</b></span><span>' +
        bankDetailsData.account_type +
        '</span></p><p style="margin: 0 0 20px; display: flex;"><span><b style="width: 150px; display: inline-block;">Bank Address:</b></span><span>' +
        bankDetailsData.address +
        "</span></p>";

      invoiceHtml7 =
        ' <p style="margin: 0 0 30px;">Please inform the online (NEFT/IMPS/UPI) / direct CHEQUE / CASH deposit details (Flat no, Transaction date, Reference no, Account holder name, Amount) by email to ' +
        societyEmail +
        '. Receipt Issue & Account Updating will be done after money transfer confirmation to society bank account.</p><div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div><p style="margin: 0 0 20px;">A Simple Interest of ' +
        invoiceData.late_fee +
        '% per month will be applied against your Unit for all Payments, against Relevant Invoices, after due date.</p><p style="margin: 0 0 20px;">Note: You are receiving this email because you are the "Primary Contact" for your Unit. If you want to change the "Primary Contact" go to My Profile page and choose the desired registered user of your Unit.</p></div></div></div></body></html>';
    }

    let bodyFormData = {
      invoiceHtml:
        invoiceHtml4 +
        "" +
        invoiceHtml5 +
        "" +
        invoiceHtml6 +
        "" +
        invoiceHtml7,
      emailId: emailId,
      subject:
        "Invoice For the Month of " +
        moment(invoiceData.invoice_date).format("MMMM"),
      ccemail: ccEmail,
    };

    await makePostRequest("invoice/sendemail", bodyFormData)
      .then((response) => {
        // if (response.data.data !== undefined) {
        //   swal("Success", "Invoice Mail Sent Successully....", "success", {
        //     timer: 1000,
        //     buttons: false,
        //   });
        //   navigate("/InvoiceListing");
        // }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  };

  // added by kailas for paid invoice

  const sendpaidemail = async (
    residentId,
    apartmentId,
    invoiceId,
    paid_date
  ) => {
    console.log("send");

    // let emailsubject;

    // if (sub === "send email") {
    //   emailsubject =
    //     "Invoice For the Month of " +
    //     moment(invoiceData.invoice_date).format("MMMM");
    // } else {
    //   emailsubject = "Invoice Paid";
    // }
    let sendEmailToTenant = false;
    let isTenantOccupied = false;
    let ccEmail = "";
    let maintenenceList = [];
    let unpaidinvoiceList = [];
    let bankDetailsData = [];

    await makeGetRequest(
      "resident/gettenantbyresidentandapartmentid/" +
      residentId +
      "/" +
      apartmentId
    )
      .then((response) => {
        if (response.status === 201) {
          // setlength(response.data.data.rowCount);
          // const data = response.data.data;
          console.log("Resident response ");
          console.log(response.data.data);
          if (response.data.data !== undefined) {
            isTenantOccupied = true;
            setCCEmailId(response.data.data.user_obj.email_id);
            ccEmail = response.data.data.user_obj.email_id;
          } else {
            isTenantOccupied = false;
            setCCEmailId("");
            ccEmail = "";
          }
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });

    if (isTenantOccupied) {
      // const willDelete = await swal({
      //   title: "This Apartment is Tenant Allocated?",
      //   text: "Do you want to want to send invoice email to tenant also.",
      //   buttons: ["No", "Yes"],
      // });

      // if (willDelete) {
      // sendEmailToTenant = true;
      sendEmailToTenant = false;
      console.log(sendEmailToTenant)

      // }
      // else
      // {
      //   sendEmailToTenant=false;
      // }
    }

    let societyName = localStorage.getItem("societyName");
    let societyAddress = localStorage.getItem("societyAddress");
    let name = "";
    let invoiceDate;
    let dueDate;
    let totalPayable;
    let invoiceData = "";
    let emailbillDate;
    let emaildueDate;
    let emailId;
    await makeGetRequest("invoice/getinvoicepreviewweb/" + invoiceId)
      .then((response) => {
        console.log("Invoice Data ", response);
        invoiceData = response.data.data;
        name =
          invoiceData.user_obj.first_name +
          " " +
          invoiceData.user_obj.last_name;
        invoiceDate = moment(invoiceData.invoice_date).format("DD-MM-YYYY");
        dueDate = moment(invoiceData.due_date).format("DD-MM-YYYY");
        totalPayable = invoiceData.total_payment - invoiceData.advance_received;

        //new
        emailbillDate = moment(invoiceData.invoice_date).format("DD-MM-YYYY");
        emaildueDate = moment(invoiceData.due_date).format("DD-MM-YYYY");
        maintenenceList = invoiceData.maintenence_json_list;
        unpaidinvoiceList = invoiceData.unpaid_invoice;

        // let calculatedTot =
        //   parseFloat(invoiceData.total_payment) -
        //   parseFloat(invoiceData.advance_received);

        bankDetailsData = invoiceData.bank_details;
        emailId = invoiceData.user_obj.email_id;
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });

    let societynumber = localStorage.getItem("societyContactNo");
    let societyEmail = localStorage.getItem("societyEmail");
    let invoiceHtml4;
    let invoiceHtml5;
    let invoiceHtml6;
    let invoiceHtml7;

    if (invoiceType === "Monthly Maintenance") {
      invoiceHtml4 =
        '<!doctype html><html><head><meta charset="utf-8"><title>Email</title><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><meta name="viewport" content="width=device-width, initial-scale=1"></head><body><div style="width: 100%; max-width: 650px; background-color: #fff; margin: 50px auto; border: 1px solid #ccc;border-radius: 10px;overflow: hidden;font-family:\'Poppins\', sans-serif; font-size: 13px;"><div style="background: #F4F3F9;text-align: center;padding: 20px;"><img src="https://suprawebservices.com/Imageskailas/newSocietyLogo.png" alt="logo" style="width:100%;max-width:150px;padding: 10px;" /></div><div style="font-weight: 900;color:#444444;font-size: 36px;text-align:center;line-height:22px;margin-bottom:15px;float: left;width: 100%;margin-top: 12px;text-shadow: 2px 0px 4px rgba(0,0,0,0.2);"> <b style="color:green;font-weight:900;letter-spacing:1px;margin-bottom: 10px;float:left;width:100%;line-height: normal;">' +
        societyName +
        '</b> <div style="font-size: 13px; display: block; margin-top: 10px;"><span>' +
        societyAddress +
        "</span><br><span>Phone : " +
        societynumber +
        ' </span></div></div> <div style=" padding: 30px 30px 0px;box-sizing: border-box;"><div style="width: 100%;float: left;text-align: center;"></div><p style="width:100%;float:left;margin-bottom: 0;margin-top:10px;font-weight:600;color:#989898;font-size:16px;text-align:center;letter-spacing:1px"><span style="color:#4A3AFF;font-size: 16px;font-weight:700;width:100%;letter-spacing:1px;text-align: center;margin-right: 14px;">Hello ' +
        invoiceData.user_obj.first_name +
        " " +
        invoiceData.user_obj.last_name +
        ',</span><p style="width:100%;float:left;padding:0 !important; margin:5px 0 !important; text-align:center;" >We hope this email finds you well,</p><p style="width: 100%;float: left;margin-top: 0;font-size: 13px;font-weight: 400;text-align: center;">Your ' + invoiceData.invoice_type + ' invoice payment for the month of <span style="font-weight:700">' +
        moment(invoiceData.invoice_date).format("MMMM-YYYY") +
        "</span> has been paid.</p><div style='font-size:13px;color:#444444;margin:30px 0 25px;float: left;width: 100%;'><div style='float: left;width: 50%;'><span style='color:#111111;font-size:13px;font-weight: 700;width: 100%;max-width: 68px;letter-spacing: 1px;'><span style='font-size: 13px;font-weight: 500;letter-spacing: 1px;'> Invoice To : <span>" +
        name +
        '</span></span><div style="float:left; padding-bottom:15px; font-size: 13px;font-weight: 500;letter-spacing: 1px;"><span style="display: block;"> Invoice No : <span>' +
        invoiceData.invoice_id +
        '</span>  </span><span style="display: block;"> Invoice Date: <span>' +
        emailbillDate +
        '</span>  </span><span style="display: block;"> Due Date: <span>' +
        emaildueDate +
        '</span>  </span><span style="display: block; color:#1d9300; font-weight:600;"> Paid On: <span>' +
        moment(paid_date).format("DD-MM-YYYY") +




        // for new changes 24-7-24











        '</span>  </span></div></div> <div style="float:right;letter-spacing: 1px;color: #111;"> <div style="text-align: right;"><span style="display: block;"> Billing Period : <span>' +
        emailbillDate +
        " to " +
        emaildueDate +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Wing / Flat No : <span>' +
        invoiceData.uniq_apt_name +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Phone : <span>' +
        invoiceData.user_obj.contact_no +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Email : <span>' +
        emailId +
        //end
        "</span> </span></div></div>";

      const arrayDataItems = maintenenceList
        .map((option, index) =>
          option.key
            ? option.total || option.total === 0
              ? '<tr style="background: #e5f7f5;color: #000;font-weight: 600;"><td style="text-align: left; padding: 5px 10px;"></td><td style="text-align: left; padding: 5px 10px;">' +
              option.key +
              " (" +
              option.value +
              '%)</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
              : '<tr style="color: #787878;font-size: 13px;font-weight: 400; height:35px "><td style="text-align: left; padding: 5px 10px;">' +
              parseInt(index + 1) +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.key +
              '</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.value).toFixed(2) +
              "</td></tr>"
            : null
        )
        .join(" ");

      let arrayunpaidList = "";

      if (unpaidinvoiceList !== null) {
        arrayunpaidList = unpaidinvoiceList
          .map(
            (optionval, index) =>
              "<tr><td>" +
              optionval.invoice_id +
              "</td><td>" +
              optionval.subject +
              "</td><td>" +
              optionval.invoice_date +
              "</td><td>" +
              optionval.due_date +
              "</td><td>₹" +
              parseFloat(optionval.total_payment).toFixed(2) +
              "</td><td>₹" +
              parseFloat(optionval.advance_received).toFixed(2) +
              "</td><td>₹" +
              parseFloat(
                optionval.total_payment - optionval.advance_received
              ).toFixed(2) +
              "</td></tr>"
          )
          .join(" ");
      }

      invoiceHtml5 =
        '<div><table style="width: 100%; border: 1px solid #f3f3f3; font-size: 13px; margin-bottom: 20px;"><thead><tr style="    background: #f5f4f4;"><th style="text-align: left; padding: 8px 10px;">Sr.No</th><th style="text-align: left; padding: 8px 10px;">Description</th><th style="text-align: right; padding: 8px 10px; width: 60px;">Amount</th></tr></thead><tbody>' +
        arrayDataItems +
        "</tbody></table></div>";

      invoiceHtml6 =
        '<div style="text-align: right; margin-bottom: 5px;">Advance Received<b style="width: 85px; display: inline-block">₹' +
        parseFloat(invoiceData.advance_received).toFixed(2) +
        '</b></div><div style="text-align: right; margin-bottom: 5px;">Current Invoice Total<b style="width: 85px; display: inline-block">₹' +
        parseFloat(totalPayable).toFixed(2) +
        '</b></div><div style="color: white;background-color: #0190ed;padding:13px 20px;border-radius:5px;font-weight:600;text-align:center;margin:15px 0 30px; letter-spacing:1px;">₹ ' +
        convertToIndianWords(
          invoiceData.total_payment,
          invoiceData.advance_received
        ).toUpperCase() +
        '</div><div><p style="margin: 0 0 10px;"><b>Use Digital payment method for Payments.</b></p><div style="display: flex"><p style="margin: 0 0 10px;"><b>Notes:-</b></p><ul style="list-style-type:decimal;margin: 0;padding-left: 26px;">' +
        (invoiceData.invoice_note &&
          '<li style="margin: 0 0 10px;">' +
          invoiceData.invoice_note +
          "</li>") +
        notesList
          .map(
            (option, index) =>
              '<li style="margin: 0 0 10px;">' + option.notes + "</li>"
          )
          .join(" ") +
        '</ul></div><p style="margin: 0 0 15px;"><b>PLEASE NOTE BANK DETAILS BELOW.</b></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Account:</b></span><span>' +
        bankDetailsData.account_holder +
        '</span></p> <p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Bank:</b></span><span>' +
        bankDetailsData.bank_name +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">IFSC Code:</b></span><span>' +
        bankDetailsData.ifsc_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">MICR Code:</b></span><span>' +
        bankDetailsData.micr_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Account No.:</b></span><span>' +
        bankDetailsData.account_no +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Type of Account:</b></span><span>' +
        bankDetailsData.account_type +
        '</span></p><p style="margin: 0 0 20px; display: flex;"><span><b style="width: 150px; display: inline-block;">Bank Address:</b></span><span>' +
        bankDetailsData.address +
        "</span></p>";

      invoiceHtml7 =
        ' <p style="margin: 0 0 30px;">Please inform the online (NEFT/IMPS/UPI) / direct CHEQUE / CASH deposit details (Flat no, Transaction date, Reference no, Account holder name, Amount) by email to ' +
        societyEmail +
        ". Receipt Issue & Account Updating will be done after money transfer confirmation to society bank account.</p>" +
        (unpaidinvoiceList !== null
          ? '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div><p style="margin: 0 0 15px; padding-top: 30px; "><b>Open Invoices:</b></p><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Invoice No.	</th><th style="text-align: left; padding: 8px 10px;">Account </th><th style="text-align: right; padding: 8px 10px; ">Invoice Date </th><th style="text-align: left; padding: 8px 10px;">Due Date	</th><th style="text-align: left; padding: 8px 10px;">Invoice Amount </th><th style="text-align: left; padding: 8px 10px;">Amount Paid </th><th style="text-align: left; padding: 8px 10px;">Amount Due</th></tr></thead><tbody>' +
          arrayunpaidList +
          '</tbody></table><div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>'
          : '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>') +
        '<p style="margin: 0 0 20px;">A Simple Interest of ' +
        invoiceData.late_fee +
        '% per month will be applied against your Unit for all Payments, against Relevant Invoices, after due date.</p><p style="margin: 0 0 20px;">Note: You are receiving this email because you are the "Primary Contact" for your Unit. If you want to change the "Primary Contact" go to My Profile page and choose the desired registered user of your Unit.</p></div></div></div></body></html>';
    } else {

      // for misch

      invoiceHtml4 =
        '<!doctype html><html><head><meta charset="utf-8"><title>Email</title><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><meta name="viewport" content="width=device-width, initial-scale=1"></head><body><div style="width: 100%; max-width: 650px; background-color: #fff; margin: 50px auto; border: 1px solid #ccc;border-radius: 10px;overflow: hidden;font-family:\'Poppins\', sans-serif; font-size: 13px;"><div style="background: #F4F3F9;text-align: center;padding: 20px;"><img src="https://suprawebservices.com/Imageskailas/newSocietyLogo.png" alt="logo" style="width:100%;max-width:150px;padding: 10px;" /></div><div style="font-weight: 900;color:#444444;font-size: 36px;text-align:center;line-height:22px;margin-bottom:15px;float: left;width: 100%;margin-top: 12px;text-shadow: 2px 0px 4px rgba(0,0,0,0.2);"> <b style="color:green;font-weight:900;letter-spacing:1px;margin-bottom: 10px;float:left;width:100%;line-height: normal;">' +
        societyName +
        '</b> <div style="font-size: 13px; display: block; margin-top: 10px;"><span>' +
        societyAddress +
        "</span><br><span>Phone : " +
        societynumber +
        ' </span></div></div> <div style=" padding: 30px 30px 0px;box-sizing: border-box;"><div style="width: 100%;float: left;text-align: center;"></div><p style="width:100%;float:left;margin-bottom: 0;margin-top:10px;font-weight:600;color:#989898;font-size:16px;text-align:center;letter-spacing:1px"><span style="color:#4A3AFF;font-size: 16px;font-weight:700;width:100%;letter-spacing:1px;text-align: center;margin-right: 14px;">Hello ' +
        invoiceData.user_obj.first_name +
        " " +
        invoiceData.user_obj.last_name +
        ',</span><p style="width:100%;float:left;padding:0 !important; margin:5px 0 !important; text-align:center;" >We hope this email finds you well,</p><p style="width: 100%;float: left;margin-top: 0;font-size: 13px;font-weight: 400;text-align: center;">Your ' + invoiceData.invoice_type + ' invoice payment for the month of <span style="font-weight:700">' +
        moment(invoiceData.invoice_date).format("MMMM-YYYY") +
        "</span> has been paid.</p><div style='font-size:13px;color:#444444;margin:30px 0 25px;float: left;width: 100%;'><div style='float: left;width: 50%;'><span style='color:#111111;font-size:13px;font-weight: 700;width: 100%;max-width: 68px;letter-spacing: 1px;'><span style='font-size: 13px;font-weight: 500;letter-spacing: 1px;'> Invoice To : <span>" +
        name +
        '</span></span><div style="float:left; padding-bottom:15px; font-size: 13px;font-weight: 500;letter-spacing: 1px;"><span style="display: block;"> Invoice No : <span>' +
        invoiceData.invoice_id +
        '</span>  </span><span style="display: block;"> Invoice Date: <span>' +
        invoiceDate +
        '</span>  </span><span style="display: block;"> Due Date: <span>' +
        dueDate +
        '</span>  </span><span style="display: block; color:#1d9300; font-weight:600;"> Paid On: <span>' +
        moment(paid_date).format("DD-MM-YYYY") +

        // for new changes 24-7-24
        '</span>  </span></div></div> <div style="float:right;letter-spacing: 1px;color: #111;"> <div style="text-align: right;"><span style="display: block;"> Billing Period : <span>' +
        emailbillDate +
        " to " +
        emaildueDate +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Wing / Flat No : <span>' +
        invoiceData.uniq_apt_name +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Phone : <span>' +
        invoiceData.user_obj.contact_no +
        '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Email : <span>' +
        emailId +
        //end
        "</span> </span></div></div>";

      const arrayDataItems = maintenenceList
        .map((option, index) =>
          option.name
            ? option.name === "CGST" ||
              option.name === "SGST" ||
              option.name === "Late Fee"
              ? '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;"></td><td style="text-align: left; padding: 5px 10px;" colspan="3">' +
              option.name +
              " (" +
              option.amount +
              '%)</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
              : '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;">' +
              parseInt(index + 1) +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.name +
              '</td><td style="text-align:left; padding: 5px 10px;">₹' +
              option.amount +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.duration +
              " " +
              option.duration_key +
              '</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
            : null
        )
        .join(" ");

      let arrayunpaidList = "";
      if (unpaidinvoiceList !== null) {
        arrayunpaidList = unpaidinvoiceList
          .map(
            (optionval, index) =>
              "<tr><td>" +
              optionval.invoice_id +
              "</td><td>" +
              optionval.subject +
              "</td><td>" +
              optionval.invoice_date +
              "</td><td>" +
              optionval.due_date +
              "</td><td>₹" +
              parseFloat(optionval.total_payment).toFixed(2) +
              "</td><td>₹" +
              parseFloat(optionval.advance_received).toFixed(2) +
              "</td><td>₹" +
              parseFloat(
                optionval.total_payment - optionval.advance_received
              ).toFixed(2) +
              "</td></tr>"
          )
          .join(" ");
      }
      invoiceHtml5 =
        '<div><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Sr.No</th><th style="text-align: left; padding: 8px 10px;">Description</th><th style="text-align: left; padding: 8px 10px;">Rate</th><th style="text-align: left; padding: 8px 10px;">Duration</th><th style="text-align: right; padding: 8px 10px; width: 60px;">Amount</th></tr></thead><tbody>' +
        arrayDataItems +
        "</tbody></table></div>";

      invoiceHtml6 =
        '<div style="text-align: right; margin-bottom: 5px;">Advance Received<b style="width: 85px; display: inline-block">₹' +
        parseFloat(invoiceData.advance_received).toFixed(2) +
        '</b></div><div style="text-align: right; margin-bottom: 5px;">Current Invoice Total<b style="width: 85px; display: inline-block">₹' +
        parseFloat(totalPayable).toFixed(2) +
        '</b></div><div style="color: green; background-color:rgb(192, 255, 192) ; padding: 13px 20px; border-radius: 5px; font-weight: 600; text-align: center; margin: 15px 0 30px;letter-spacing:1px;">₹ ' +
        convertToIndianWords(
          invoiceData.total_payment,
          invoiceData.advance_received
        ).toUpperCase() +
        '</div><div><p style="margin: 0 0 10px;"><b>Use Digital payment method for Payments.</b></p><p style="margin: 0 0 10px;"><b>Notes:-</b></p><ul style="  padding-left: 14px;list-style-type: decimal;">' +
        (invoiceData.invoice_note &&
          '<li style="margin: 0 0 10px;">' +
          invoiceData.invoice_note +
          "</li>") +
        notesList
          .map(
            (option, index) =>
              '<li style="margin: 0 0 10px;">' + option.notes + "</li>"
          )
          .join(" ") +
        '</ul><p style="margin: 0 0 15px;"><b>PLEASE NOTE BANK DETAILS BELOW.</b></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Account:</b></span><span>' +
        bankDetailsData.account_holder +
        '</span></p> <p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Bank:</b></span><span>' +
        bankDetailsData.bank_name +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">IFSC Code:</b></span><span>' +
        bankDetailsData.ifsc_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">MICR Code:</b></span><span>' +
        bankDetailsData.micr_code +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Account No.:</b></span><span>' +
        bankDetailsData.account_no +
        '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Type of Account:</b></span><span>' +
        bankDetailsData.account_type +
        '</span></p><p style="margin: 0 0 20px; display: flex;"><span><b style="width: 150px; display: inline-block;">Bank Address:</b></span><span>' +
        bankDetailsData.address +
        "</span></p>";

      invoiceHtml7 =
        ' <p style="margin: 0 0 30px;">Please inform the online (NEFT/IMPS/UPI) / direct CHEQUE / CASH deposit details (Flat no, Transaction date, Reference no, Account holder name, Amount) by email to ' +
        societyEmail +
        ". Receipt Issue & Account Updating will be done after money transfer confirmation to society bank account.</p>" +
        (unpaidinvoiceList !== null
          ? '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div><p style="margin: 0 0 15px; padding-top: 30px; "><b>Open Invoices:</b></p><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Invoice No.	</th><th style="text-align: left; padding: 8px 10px;">Account </th><th style="text-align: right; padding: 8px 10px; ">Invoice Date </th><th style="text-align: left; padding: 8px 10px;">Due Date	</th><th style="text-align: left; padding: 8px 10px;">Invoice Amount </th><th style="text-align: left; padding: 8px 10px;">Amount Paid </th><th style="text-align: left; padding: 8px 10px;">Amount Due</th></tr></thead><tbody>' +
          arrayunpaidList +
          '</tbody></table><div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>'
          : '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>') +
        '<p style="margin: 0 0 20px;">A Simple Interest of ' +
        invoiceData.late_fee +
        '% per month will be applied against your Unit for all Payments, against Relevant Invoices, after due date.</p><p style="margin: 0 0 20px;">Note: You are receiving this email because you are the "Primary Contact" for your Unit. If you want to change the "Primary Contact" go to My Profile page and choose the desired registered user of your Unit.</p></div></div></div></body></html>';
    }

    let bodyFormData = {
      invoiceHtml:
        invoiceHtml4 +
        "" +
        invoiceHtml5 +
        "" +
        invoiceHtml6 +
        "" +
        invoiceHtml7,
      emailId: emailId,
      subject: `Thank you: your invoice no.-${invoiceData.invoice_id} has been paid.`,

      ccemail: ccEmail,
    };

    await makePostRequest("invoice/sendemail", bodyFormData)
      .then((response) => {
        // if (response.data.data !== undefined) {
        //   swal("Success", "Invoice Mail Sent Successully....", "success", {
        //     timer: 1000,
        //     buttons: false,
        //   });
        //   navigate("/InvoiceListing");
        // }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  };
  const deleteAll = async () => {
    setShowLoader(true);
    try {
      const response = await makeGetRequest("invoice/deleteAllRecords");
      console.log("Success:", response.data);

      if (response.status === 201) {
        //

        let inputdata = {
          // stype: selectedOption,
          current_date: null,
          end_date: null,
          sid: 1,
        };
        const insertResponse = await makePostRequest(
          "invoice/updateSchedulerData",
          inputdata
        )
        console.log(insertResponse)
          .then((response) => {
            console.log("first", response.data.data);
            if (response.data.data !== undefined) {
              swal("Success", "Invoice records deleted successfully");
              InvoiceListing();
            }
          })
          .catch((err) => {
            console.log("nnn", err);
            swal("There was an error!", "more error details", "warning");
            setShowLoader(false);
          });

        setShowLoader(false);
        InvoiceListing();
      } else {
        console.error("Error:", response.status);
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      }
    } catch (error) {
      setShowLoader(false);
      console.error("Error:", error);
      swal("There was an error!", "more error details", "warning");
    }
  };

  // tenent and owner list
  const [residentlist, setresidentlist] = React.useState([]);
  const [selectedResidentoption, setSelectedResidentoption] = useState("");

  async function residentlisting() {
    setShowLoader(true);
    await makeGetRequest("resident/getallaprtuserwithaprt")
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          setresidentlist(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleChangeSelection = (event) => {
    console.log(event.target.value);
    setSelectedResidentoption(event.target.value);
    setQ(event.target.value);
  };

  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
 const downloadIndividualPDFs = async () => {
     setShowLoader(true);
     // invoice class name
     const invoiceElements = document.querySelectorAll('.invoice-container');
 
     for (const invoiceEl of invoiceElements) {
       const firstName = invoiceEl.getAttribute('data-firstname');
       const lastName = invoiceEl.getAttribute('data-lastname');
       const invoiceDate = invoiceEl.getAttribute('data-invoicedate');
       const invoicename = invoiceEl.getAttribute('data-type');
 
    
       const filename = `${invoicename}_${firstName}_${lastName}_${invoiceDate}.pdf`;
 
       const options = {
         margin: 0.5,
         filename: filename,
         image: { type: 'jpeg', quality: 0.98 },
         html2canvas: { scale: 2 },
         jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
       };
 
     
       await html2pdf().set(options).from(invoiceEl).save();
 
    
       await delay(500);
     }
     setShowLoader(false);
   };


  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut createInvoicePrintMain">
              <div className="visitorHead">Invoice Management</div>

              <div className="topBSectMain">
                {/* added by me new change    */}

                {/* for alptech demo */}
                {(localStorage.getItem("societyName") ===
                  "Alptech Demo Society") && (
                    <Button className="sendemailBtn" onClick={deleteAll}>
                      Delete all
                    </Button>
                  )}

                <Button className="sendemailBtn" onClick={createEmail}>
                  Send Email
                </Button>

                {/* <Button className="sendemailBtn" onClick={archiveInvoice}>
                Archive Invoices
                </Button> */}

                <Button className="sendemailBtn" onClick={downloadIndividualPDFs}>
                  Download Invoices as PDF
                </Button>

                <CsvDownloader
                  className="sendemailBtn"
                  filename="invoice-report"
                  extension=".csv"
                  datas={csvdataarray}
                  text="Export To Excel"
                />

                <Tooltip title="Print All Invoices" placement="top" arrow>
                  <img
                    src={printIcon}
                    className="newPrintIcon"
                    alt="printicon"
                    onClick={() => printAllInvoices("printableArea")}
                  />
                </Tooltip>
              </div>

              {/* end */}

              {/* print code */}


              {/* new cha */}
              {invoiceType === "Monthly Maintenance" && (
                <div
                  className="InvoicePreviewInnerMain pageJump"
                  id="printableArea"
                  style={{ display: "none" }}
                >
                  {monthly_InvoiceList.map((invoiceData, index) => (
                    //  Add class "invoice-container" to each invoice for individual PDF generation
                    <div key={index} className="invoice-container page-break2"
                      data-firstname={invoiceData.user_obj.first_name}
                      data-lastname={invoiceData.user_obj.last_name}
                      data-invoicedate={convertDate(invoiceData.invoice_date)}
                      data-type="Monthly_Maintenance"
                    >
                      <div className="myNewPrintHeadMain">
                        <div className="newLogOut">
                          <img src={newSocietylogo} alt="Society Logo" />
                        </div>
                        <div className="societyNameAd">
                          <h2 className="invoicePreviHeading" style={{ display: "block" }}>
                            {localStorage.getItem("societyName")}
                          </h2>
                          <p className="invoicePreviSubHeading textAli">
                            {localStorage.getItem("societyAddress")}
                          </p>
                        </div>
                      </div>
                      <div className="newPrintTopMain">
                        <div className="newPrintTopMainInr">
                          <div className="printTopDetLine">
                            <p>Invoice No</p>
                            <b>: {invoiceData.invoice_id}</b>
                          </div>
                          <div className="printTopDetLine">
                            <p>Invoice Date</p>
                            <b>: {convertDate(invoiceData.invoice_date)}</b>
                          </div>
                          <div className="printTopDetLine">
                            <p>Invoice to</p>
                            <b>
                              : {invoiceData.user_obj.first_name}{" "}
                              {invoiceData.user_obj.last_name}
                            </b>
                          </div>
                          <div className="printTopDetLine">
                            <p>Wing / Flat No</p>
                            <b>: {invoiceData.uniq_apt_name}</b>
                          </div>
                        </div>

                        <div className="newPrintTopMainInr">
                          <div className="printTopDetLine">
                            <p>Due Date</p>
                            <b>: {convertDate(invoiceData.invoice_date)}</b>
                          </div>
                          <div className="printTopDetLine">
                            <p>Phone</p>
                            <b>: {invoiceData.user_obj.contact_no}</b>
                          </div>
                          <div className="printTopDetLine">
                            <p>Billing Period</p>
                            <b>
                              : {convertDate(invoiceData.invoice_date)} to{" "}
                              {convertDate(invoiceData.invoice_date)}
                            </b>
                          </div>
                          <div className="printTopDetLine">
                            <p>Email</p>
                            <b>: {invoiceData.user_obj.email_id}</b>
                          </div>
                        </div>
                      </div>
                      <div className="invoiceTaleSecMain">
                        <table className="invoiceTale">
                          <thead>
                            <tr>
                              <th>Sr No.</th>
                              <th>Description</th>
                              <th align="center">Amount</th>
                            </tr>
                          </thead>

                          <tbody>
                            {invoiceData.maintenence_json_list.map((option, idx) =>
                              option.total || option.total === 0 ? (
                                <tr key={idx}>
                                  <td></td>
                                  <td>
                                    {option.key}{" "}
                                    <span className="persSt">({option.value}%)</span>
                                  </td>
                                  <td align="center">
                                    <CurrencyRupeeIcon />{" "}
                                    {parseFloat(option.total).toFixed(2)}
                                  </td>
                                </tr>
                              ) : (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>{option.key}</td>
                                  <td align="center">
                                    <CurrencyRupeeIcon />{" "}
                                    {parseFloat(option.value).toFixed(2)}
                                  </td>
                                </tr>
                              )
                            )}
                            <tr>
                              <td className="ftText highLightAmount"></td>
                              <td className="ftText highLightAmount" align="right">
                                Current Invoice Total
                              </td>
                              <td className="ftText highLightAmount" align="center">
                                <CurrencyRupeeIcon />{" "}
                                {parseFloat(invoiceData.total_payment).toFixed(2)}
                              </td>
                            </tr>

                            <tr>
                              <td></td>
                              <td>Advance Received</td>
                              <td align="center">
                                <CurrencyRupeeIcon />{" "}
                                {parseFloat(invoiceData.advance_received).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="ftText highLightAmount"></td>
                              <td className="ftText highLightAmount" align="right">
                                Total Payable
                              </td>
                              <td className="ftText highLightAmount" align="center">
                                <CurrencyRupeeIcon />{" "}
                                {calcTotalPayment(
                                  invoiceData.total_payment,
                                  invoiceData.advance_received
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>
                                <p className="invoiceHeadCont invoiceHeadContNew">
                                  <b>Amount in Words: </b>
                                  <span className="textTrans">
                                    <CurrencyRupeeIcon />{" "}
                                    {convertToIndianWords(
                                      invoiceData.total_payment,
                                      invoiceData.advance_received
                                    )}
                                  </span>
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="noteMain">
                        {invoiceData.bank_details && (
                          <div className="bankDetailsMain">
                            <h1>Bank Details</h1>
                            <p className="bankDetailsCont">
                              <b>Name of Account :</b>{" "}
                              <span>{invoiceData.bank_details.account_holder}</span>
                            </p>
                            <p className="bankDetailsCont">
                              <b>Bank name :</b>{" "}
                              <span>{invoiceData.bank_details.bank_name}</span>
                            </p>
                            <p className="bankDetailsCont">
                              <b>Account Number :</b>{" "}
                              <span>{invoiceData.bank_details.account_no}</span>
                            </p>
                            <p className="bankDetailsCont">
                              <b>Account type :</b>{" "}
                              <span>{invoiceData.bank_details.account_type}</span>
                            </p>
                            <p className="bankDetailsCont">
                              <b>IFSC Code :</b>{" "}
                              <span>{invoiceData.bank_details.ifsc_code}</span>
                            </p>
                            <p className="bankDetailsCont">
                              <b>MICR Code :</b>{" "}
                              <span>{invoiceData.bank_details.micr_code}</span>
                            </p>
                            <p className="bankDetailsCont">
                              <b>UPI ID :</b>{" "}
                              <span>{invoiceData.bank_details.upi_id}</span>
                            </p>
                            <p className="bankDetailsCont">
                              <b>Bank Address :</b>{" "}
                              <span>{invoiceData.bank_details.address}</span>
                            </p>
                          </div>
                        )}
                        <div className="noteInner noteStUl" style={{ borderRight: "none" }}>
                          <b>Note :</b>
                          <ul>
                            {invoiceData.invoice_note !== "" && <li>{invoiceData.invoice_note}</li>}
                            {notesList.map((option, idx) => (
                              <li key={idx}>{option.notes}</li>
                            ))}
                          </ul>
                        </div>
                      </div>{" "}
                    </div>
                  ))}
                </div>
              )}

              {invoiceType === "Miscellaneous" && (
                <div
                  className="InvoicePreviewInnerMain"
                  id="printableArea"
                  style={{ display: "none" }}
                >
                  {misc_invoiceList.map((invoiceData, index) => (
                    <div key={index} className="invoice-container page-break2"
                    data-firstname={invoiceData.user_obj.first_name}
                      data-lastname={invoiceData.user_obj.last_name}
                      data-invoicedate={convertDate(invoiceData.invoice_date)}
                      data-type="Miscellaneous"
                    >
                      <div className="newLogOut">
                        <img src={newSocietylogo} alt="altimg"/>
                      </div>
                      <h2
                        className="invoicePreviHeading textAli"
                        style={{
                          pageBreakAfter: "always",
                          textAlign: "center",
                        }}
                      >
                        {localStorage.getItem("societyName")}
                      </h2>
                      <p className="invoicePreviSubHeading textAli">
                        {localStorage.getItem("societyAddress")}
                      </p>
                      <table className="invoiceTale">
                        <thead>
                          <tr>
                            <th>
                              <p className="invoiceHeadCont">
                                <b>Invoice No :</b>
                                <span>{invoiceData.invoice_id}</span>
                              </p>
                            </th>
                            <th>
                              <p className="invoiceHeadCont">
                                <b>Invoice Date :</b>

                                <span>
                                  {convertDate(invoiceData.invoice_date)}
                                </span>
                              </p>
                            </th>
                            <th>
                              <p className="invoiceHeadCont">
                                <b>Due Date :</b>
                                <span>
                                  {convertDate(invoiceData.invoice_date)}
                                </span>
                              </p>
                            </th>
                            <th>
                              <p className="invoiceHeadCont">
                                <b>Billing Period :</b>
                                <span>
                                  {convertDate(invoiceData.invoice_date)} to{" "}
                                  {convertDate(invoiceData.invoice_date)}
                                </span>
                              </p>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <p className="invoiceHeadCont">
                                <b>Invoice to :</b>
                                <span>
                                  {invoiceData.user_obj.first_name}{" "}
                                  {invoiceData.user_obj.last_name}
                                </span>
                              </p>
                            </td>
                            <td>
                              <p className="invoiceHeadCont">
                                <b>Wing / Flat No :</b>
                                <span>{invoiceData.uniq_apt_name}</span>
                              </p>
                            </td>
                            <td>
                              <p className="invoiceHeadCont">
                                <b>Phone :</b>
                                <span>{invoiceData.user_obj.contact_no}</span>
                              </p>
                            </td>
                            <td>
                              <p className="invoiceHeadCont">
                                <b>Email :</b>
                                <span>{invoiceData.user_obj.email_id}</span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="invoiceTaleSecMain">
                        <table className="invoiceTale">
                          <thead>
                            <tr>
                              <th>Sr No.</th>
                              <th>Description</th>
                              <th>Rate</th>
                              <th>Duration</th>
                              <th align="center">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoiceData.maintenence_json_list.map(
                              (option, index) => (
                                <>
                                  {option.name !== "CGST" &&
                                    option.name !== "SGST" &&
                                    option.name !== "Late Fee" ? (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{option.name}</td>
                                      <td align="center">
                                        <CurrencyRupeeIcon />
                                        <span className="rightSpaceS">
                                          {parseFloat(option.amount).toFixed(2)}
                                        </span>
                                        {option.duration_key}
                                      </td>
                                      <td>
                                        <b className="duraAmount">
                                          {option.duration}
                                        </b>
                                        {option.duration_key === "/hour" ? (
                                          <>Hours</>
                                        ) : (
                                          <>Days</>
                                        )}
                                      </td>
                                      <td>
                                        <CurrencyRupeeIcon />{" "}
                                        {parseFloat(option.total).toFixed(2)}
                                      </td>
                                    </tr>
                                  ) : (
                                    <tr>
                                      <td></td>
                                      <td>
                                        {option.name}{" "}
                                        <span className="persSt">
                                          ({option.amount}%)
                                        </span>
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center">
                                        <CurrencyRupeeIcon />{" "}
                                        {parseFloat(option.total).toFixed(2)}
                                      </td>
                                    </tr>
                                  )}
                                </>
                              )
                            )}

                            <tr>
                              <td className="ftText highLightAmount"></td>
                              <td
                                className="ftText highLightAmount"
                                align="right"
                              >
                                Current Invoice Total
                              </td>
                              <td className="ftText highLightAmount"></td>
                              <td className="ftText highLightAmount"></td>
                              <td
                                className="ftText highLightAmount"
                                align="center"
                              >
                                <CurrencyRupeeIcon />{" "}
                                {parseFloat(invoiceData.total_payment).toFixed(
                                  2
                                )}
                              </td>
                            </tr>

                            <tr>
                              <td></td>
                              <td className="ftText" align="right">
                                Advance Received
                              </td>
                              <td></td>
                              <td></td>
                              <td className="ftText" align="center">
                                <CurrencyRupeeIcon />{" "}
                                {parseFloat(
                                  invoiceData.advance_received
                                ).toFixed(2)}
                              </td>
                            </tr>

                            <tr>
                              <td className="ftText highLightAmount"></td>
                              <td
                                className="ftText highLightAmount"
                                align="right"
                              >
                                Total Payable
                              </td>
                              <td className="ftText highLightAmount"></td>
                              <td className="ftText highLightAmount"></td>
                              <td
                                className="ftText highLightAmount"
                                align="center"
                              >
                                <CurrencyRupeeIcon />{" "}
                                {calcTotalPayment(
                                  invoiceData.total_payment,
                                  invoiceData.advance_received
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={5}>
                                <p className="invoiceHeadCont invoiceHeadContNew">
                                  <b>Amount in Words: </b>
                                  <span className="textTrans">
                                    {convertToIndianWords(
                                      invoiceData.total_payment,
                                      invoiceData.advance_received
                                    )}
                                  </span>
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="noteMain">
                        {invoiceData.bank_details && (
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={8}>
                              <div className="bankDetailsMain">
                                <h1>Bank Details</h1>
                                <p className="bankDetailsCont">
                                  <b>Name of Account :</b>
                                  <span>
                                    {invoiceData.bank_details.account_holder}
                                  </span>
                                </p>
                                <p className="bankDetailsCont">
                                  <b>Bank name :</b>
                                  <span>
                                    {invoiceData.bank_details.bank_name}
                                  </span>
                                </p>

                                <p className="bankDetailsCont">
                                  <b>Account Number :</b>
                                  <span>
                                    {invoiceData.bank_details.account_no}
                                  </span>
                                </p>
                                <p className="bankDetailsCont">
                                  <b>Account type :</b>
                                  <span>
                                    {invoiceData.bank_details.account_type}
                                  </span>
                                </p>
                                <p className="bankDetailsCont">
                                  <b>IFSC Code :</b>
                                  <span>
                                    {invoiceData.bank_details.ifsc_code}
                                  </span>
                                </p>
                                <p className="bankDetailsCont">
                                  <b>MICR Code :</b>
                                  <span>
                                    {invoiceData.bank_details.micr_code}
                                  </span>
                                </p>
                                <p className="bankDetailsCont">
                                  <b>UPI ID :</b>
                                  <span>{invoiceData.bank_details.upi_id}</span>
                                </p>
                                <p className="bankDetailsCont">
                                  <b>Bank Address :</b>
                                  <span>
                                    {invoiceData.bank_details.address}
                                  </span>
                                </p>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4} className="stambBox">
                              <div className="noteInner">
                                Secretary / Chairman / Treasurer
                              </div>
                            </Grid>
                          </Grid>
                        )}

                        <Grid container spacing={3}>
                          <Grid item xs={12} md={12}>
                            <div
                              className="noteInner noteStUl"
                              style={{ borderRight: "none" }}
                            >
                              <b>Note :</b>
                              <ul>
                                {invoiceData.invoice_note !== "" ? (
                                  <li>{invoiceData.invoice_note}</li>
                                ) : null}
                                {notesList.map((option, index) => (
                                  <li>{option.notes}</li>
                                ))}
                              </ul>
                            </div>
                          </Grid>
                        </Grid>
                      </div>{" "}
                    </div>
                  ))}{" "}
                </div>
              )}
              <div className="invoicePaidUnpaidTabMain">
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                    >
                      <Tab
                        label="Monthly Maintenance Invoices"
                        {...a11yProps(0)}
                        onClick={() => handleChangeTabs("Monthly Maintenance")}
                      />
                      <Tab
                        label="Miscellaneous Invoices"
                        {...a11yProps(1)}
                        onClick={() => handleChangeTabs("Miscellaneous")}
                      />
                    </Tabs>
                  </Box>
                  <TabPanel value={value} index={0}>
                    <div className="visitorListNewInner">
                      <div
                        className="visitorSearch newRefBtOut"
                        style={{ marginBottom: 7 }}
                      >
                        <div className="visitorSearchDiv invoiceSearch">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search by name/emailid/contact no/apartment no./date"
                            onChangeCapture={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>
                        <h5>Or</h5>
                        {/* added by vaishali static*/}
                        {/* <FormControl>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={age}
                            className="ticketDrop invoiceListDrop"
                          >
                            <MenuItem value="Select" className="largWid">
                              <p className="checkLineTx">
                                Name <KeyboardDoubleArrowRightIcon />
                                <span>one</span>
                                <b className="tenInDrop">(Tenant Occupied)</b>
                              </p>
                            </MenuItem>

                            <MenuItem value="Select">
                              <p className="checkLineTx">
                                Name <KeyboardDoubleArrowRightIcon />
                                <span>one</span>
                                <b className="tenInDrop">(Vacant)</b>
                              </p>
                            </MenuItem>
                          </Select>
                        </FormControl> */}

                        {/* added by me for listing dropdown dynamic*/}

                        <FormControl>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedResidentoption}
                            onChange={handleChangeSelection}
                            className="ticketDrop invoiceListDrop"
                          >
                            {residentlist.map((res, index) => (
                              <MenuItem
                                key={index}
                                value={res.apt_name}
                                className="largWid"
                              >
                                <p className="checkLineTx">
                                  {res.user_obj.first_name}{" "}
                                  {res.user_obj.last_name}{" "}
                                  <KeyboardDoubleArrowRightIcon />
                                  <span>{res.apt_name}</span>
                                  <b className="tenInDrop">
                                    ({res.occupancy_type})
                                  </b>
                                </p>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {/* <FormControl>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedResidentoption}
                            onChange={handleChangeSelection}
                            className="ticketDrop invoiceListDrop"
                          >
                            {residentlist.map((res,index) => (
                              <MenuItem key={index} value={res.user_obj.first_name}>
                                <p className="checkLineTx">
                                  {res.user_obj.first_name}{" "}{res.user_obj.last_name}
                                  <KeyboardDoubleArrowRightIcon />
                                  <span>{res.apt_name}</span>
                                </p>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl> */}

                        <div>
                          <SortIcon
                            className="visitorFilterIco"
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClick}
                          />
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => handleAll()}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                          >
                            <MenuItem onClick={() => handleAll()}>
                              All Invoice
                            </MenuItem>
                            <MenuItem onClick={() => handleClose("true")}>
                              Paid Invoice
                            </MenuItem>
                            <MenuItem onClick={() => handleClose("false")}>
                              Unpaid Invoice
                            </MenuItem>
                          </Menu>
                        </div>
                        <Tooltip title="Refresh" placement="top" arrow>
                          <Button
                            className="refB"
                            onClick={() => {
                              setQ("");
                              setSelectedResidentoption("");
                            }}
                          >
                            <SettingsBackupRestoreIcon />
                          </Button>
                        </Tooltip>
                      </div>

                      {/* added by me for send email */}

                      <div className="allSelectCheckSt">
                        {monthly_InvoiceList.length > 0 && (
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isSelectAllChecked}
                                  onChange={(e) =>
                                    handleSelectAllChange(e, "monthly")
                                  }
                                />
                              }
                              label="Select All"
                            />
                          </FormGroup>
                        )}

                        <h4 className="inPaidUnPaidHe">
                          Total Paid Invoices:{paidCount}
                        </h4>
                        <h4 className="inPaidUnPaidHe">
                          Total Unpaid Invoices:{unpaidCount}
                        </h4>
                      </div>

                      {monthly_InvoiceList.map((option) => (
                        // {option.is_paid?
                        <div className="visitContDiv paidInvoice">
                          {/* : 
                        <div className="visitContDiv unPaidInvoice">} */}

                          <div className="myCheackMain">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedInvoice.includes(
                                      option.invoice_id
                                    )}
                                    onChange={(e) =>
                                      handleUserCheckboxChange(
                                        option.apartment_id,
                                        option.resident_id,
                                        option.invoice_id,
                                        e.target.checked
                                      )
                                    }
                                  />
                                }
                              />
                            </FormGroup>
                          </div>

                          {/* <FormGroup>
                        <FormControlLabel
                          control={<Checkbox  />}
                          label="Auto Archive"
                        />
                      </FormGroup> */}

                          <div className="visitCont1">

                            <div className="visitContProf">
                              <Zoom>
                                {option.user_obj.profile_pic ? (
                                  <img src={option.user_obj.profile_pic} alt="altimg"/>
                                ) : (
                                  <img src={defaultProfilePic} alt="altimg"/>
                                )}
                              </Zoom>
                            </div>

                            <div className="visitContLeft">
                              <h3 className="visitContHed">
                                {option.user_obj.first_name}{" "}
                                {option.user_obj.last_name}
                              </h3>
                              <p className="visitContMob">
                                {option.user_obj.contact_no}
                              </p>
                              <p className="visitContTime">
                                {option.user_obj.email_id}
                              </p>
                            </div>
                            <div className="visitBottCont">
                              <span className="tenInfTTx">
                                {option.tenent_info && (
                                  <>
                                    {option.tenent_info.tenentfname}
                                    {"  "}
                                    {option.tenent_info.tenentlname}
                                  </>
                                )}

                                <p className="visitContTime">
                                  ({option.occupancy_type})
                                </p>
                              </span>
                              <p>Building/Wing/Flat Number</p>
                              <b>{option.uniq_apt_name}</b>{" "}
                              {/* added by me for tenent info */}
                            </div>

                            <div className="visitContRight">
                              <div className="visitBottCont billAmount">
                                <p>Invoice Amount :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />
                                  {parseFloat(option.total_payment).toFixed(2)}
                                </b>
                              </div>
                              <div className="visitBottCont billAmount">
                                <p>Advance :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />
                                  {parseFloat(option.advance_received).toFixed(
                                    2
                                  )}
                                </b>
                              </div>

                              <div className="visitBottCont billAmount lateFee">
                                <p>Late Fee :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />
                                  {parseFloat(option.late_fee).toFixed(2)}
                                </b>
                              </div>
                              <div className="visitBottCont billAmount totalDue">
                                <p>Total Due :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />
                                  {/* {parseFloat(option.total_payment) -
                                    parseFloat(option.advance_received)} */}
                                  {ParseNumberFloat(
                                    option.total_payment,
                                    option.advance_received
                                  )}
                                </b>
                              </div>
                            </div>
                          </div>

                          <div className="visitCont2">
                            <div className="visitBottCont">
                              <p>Invoice Date</p>
                              <b>
                                {moment(option.invoice_date).format(
                                  "DD-MM-YYYY"
                                )}
                              </b>
                            </div>
                            {/* added invoiceListBottomLeftMrgin cls by vaishal for tenent info*/}
                            <div className="visitBottCont invoiceListBottomLeftMrgin">
                              <p>Due Date</p>
                              <b>
                                {moment(option.due_date).format("DD-MM-YYYY")}
                              </b>
                            </div>
                            <div className="resideNewCont">
                              {option.late_fee > 0 && (
                                <Tooltip title="Late Fee" placement="top" arrow>
                                  <div className="lateFeeIco">
                                    <img alt="altimg"
                                      src={latefees}
                                      onClick={() =>
                                        navigate(
                                          "/WaveLateFee/" + option.invoice_id
                                        )
                                      }
                                    />
                                  </div>
                                </Tooltip>
                              )}
                              {option.is_paid ? (
                                <></>
                              ) : (
                                <CreateIcon
                                  className="editBt"
                                  onClick={() =>
                                    navigate(
                                      "/EditInvoice/" + option.invoice_id
                                    )
                                  }
                                />
                              )}
                              <SearchIcon
                                className="editBt"
                                onClick={() =>
                                  navigate(
                                    "/MonthlyMaintenInvoicesPreview/" +
                                    option.invoice_id
                                  )
                                }
                              />

                              {option.is_paid ? (
                                <div>
                                  <Button
                                    className="paidBtn"
                                    onClick={handleClickOpen(
                                      "body",
                                      option,
                                      "edit"
                                    )}
                                  >
                                    Mark As UnPaid
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  className="paidBtn"
                                  onClick={handleClickOpen(
                                    "body",
                                    option,
                                    "add"
                                  )}
                                >
                                  Pay Now
                                </Button>
                              )}
                            </div>
                          </div>
                          {option.paid_note ? (
                            <div className="noteTop">
                              <h3 className="visitContHed">Note :</h3>
                              <i>
                                <p className="visitContMob">
                                  {option.paid_note}
                                </p>
                              </i>
                              <p className="visitContMob">
                                <span>(</span>
                                {moment(option.note_added_time).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                {moment(option.note_added_time).format(
                                  "hh:mm:ss A"
                                )}
                                <span>)</span>
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      ))}
                    </div>
                  </TabPanel>

                  <TabPanel value={value} index={1}>
                    <div className="visitorListNewInner">
                      <div className="visitorSearch newRefBtOut">
                        <div className="visitorSearchDiv invoiceSearch">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search by name/emailid/contact no/apartment no./date"
                            onChangeCapture={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>
                        <h5>Or</h5>
                        {/* added by me for listing dropdown */}
                        <FormControl>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedResidentoption}
                            onChange={handleChangeSelection}
                            className="ticketDrop invoiceListDrop"
                          >
                            {residentlist.map((res, index) => (
                              <MenuItem
                                key={index}
                                value={res.apt_name}
                                className="largWid"
                              >
                                <p className="checkLineTx">
                                  {res.user_obj.first_name}{" "}
                                  {res.user_obj.last_name}{" "}
                                  <KeyboardDoubleArrowRightIcon />
                                  <span>{res.apt_name}</span>
                                  <b className="tenInDrop">
                                    ({res.occupancy_type})
                                  </b>
                                </p>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <div>
                          <SortIcon
                            className="visitorFilterIco"
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClick}
                          />
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => handleAll()}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                          >
                            <MenuItem onClick={() => handleClose("true")}>
                              Paid Invoice
                            </MenuItem>
                            <MenuItem onClick={() => handleClose("false")}>
                              Unpaid Invoice
                            </MenuItem>
                          </Menu>
                        </div>
                        <Tooltip title="Refresh" placement="top" arrow>
                          <Button
                            className="refB"
                            onClick={() => {
                              setQ("");
                              setSelectedResidentoption("");
                            }}
                          >
                            <SettingsBackupRestoreIcon />
                          </Button>
                        </Tooltip>
                      </div>

                      {/* added by me for send email */}

                      <div className="allSelectCheckSt">
                        {misc_invoiceList.length > 0 && (
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isSelectAllChecked}
                                  onChange={(e) =>
                                    handleSelectAllChange(e, "misch")
                                  }
                                />
                              }
                              label="Select All"
                            />
                          </FormGroup>
                        )}

                        <h4 className="inPaidUnPaidHe">
                          Total Paid Invoices:{paidCount}
                        </h4>
                        <h4 className="inPaidUnPaidHe">
                          Total Unpaid Invoices:{unpaidCount}
                        </h4>
                      </div>

                      {misc_invoiceList.map((option) => (
                        // {option.is_paid?
                        <div className="visitContDiv paidInvoice">
                          <div className="myCheackMain">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedInvoice.includes(
                                      option.invoice_id
                                    )}
                                    onChange={(e) =>
                                      handleUserCheckboxChange(
                                        option.apartment_id,
                                        option.resident_id,
                                        option.invoice_id,
                                        e.target.checked
                                      )
                                    }
                                  />
                                }
                              />
                            </FormGroup>
                          </div>
                          {/* : 
                        <div className="visitContDiv unPaidInvoice">} */}
                          <div className="visitCont1">
                            <div className="visitContProf">
                              <Zoom>
                                {option.user_obj.profile_pic ? (
                                  <img src={option.user_obj.profile_pic} alt="altimg"/>
                                ) : (
                                  <img src={defaultProfilePic} alt="altimg"/>
                                )}
                              </Zoom>
                            </div>
                            <div className="visitContLeft">
                              <h3 className="visitContHed">
                                {option.user_obj.first_name}{" "}
                                {option.user_obj.last_name}
                              </h3>
                              <p className="visitContMob">
                                {option.user_obj.contact_no}
                              </p>
                              <p className="visitContTime">
                                {option.user_obj.email_id}
                              </p>
                            </div>
                            <div className="visitBottCont">
                              {/* <p>Wing/Flat Number</p>
                              <b>{option.uniq_apt_name}</b> */}

                              {/* added by me for tenent info */}
                              <span className="tenInfTTx">
                                {option.tenent_info && (
                                  <>
                                    {option.tenent_info.tenentfname}{" "}
                                    {option.tenent_info.tenentlname}
                                  </>
                                )}
                                <p className="visitContTime">
                                  ({option.occupancy_type})
                                </p>
                              </span>
                              <p>Building/Wing/Flat Number</p>
                              <b>{option.uniq_apt_name}</b>
                            </div>
                            <div className="visitContRight">
                              <div className="visitBottCont billAmount">
                                <p>Invoice Amount :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />{" "}
                                  {parseFloat(option.total_payment).toFixed(2)}
                                </b>
                              </div>
                              <div className="visitBottCont billAmount">
                                <p>Advance :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />
                                  {parseFloat(option.advance_received).toFixed(
                                    2
                                  )}
                                </b>
                              </div>
                              <div className="visitBottCont billAmount lateFee">
                                <p>Late Fee :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />{" "}
                                  {parseFloat(option.late_fee).toFixed(2)}
                                </b>
                              </div>
                              <div className="visitBottCont billAmount totalDue">
                                <p>Total Due :</p>
                                <b className="amountSt">
                                  <CurrencyRupeeIcon />
                                  {ParseNumberFloat(
                                    option.total_payment,
                                    option.advance_received
                                  )}
                                  {/* {option.total_payment -
                                    option.advance_received} */}
                                </b>
                              </div>
                            </div>
                          </div>

                          <div className="visitCont2">
                            <div className="visitBottCont">
                              <p>Invoice Date</p>
                              <b>
                                {moment(option.invoice_date).format(
                                  "DD-MM-YYYY"
                                )}
                              </b>
                            </div>
                            <div className="visitBottCont">
                              <p>Due Date</p>
                              <b>
                                {moment(option.due_date).format("DD-MM-YYYY")}
                              </b>
                            </div>
                            <div className="resideNewCont">
                              {option.late_fee > 0 && (
                                <Tooltip title="Late Fee" placement="top" arrow>
                                  <div className="lateFeeIco">
                                    <img alt="altimg"
                                      src={latefees}
                                      onClick={() =>
                                        navigate(
                                          "/WaveLateFee/" + option.invoice_id
                                        )
                                      }
                                    />
                                  </div>
                                </Tooltip>
                              )}
                              {!option.is_paid && (
                                <CreateIcon
                                  className="editBt"
                                  onClick={() =>
                                    navigate(
                                      "/EditMiscellaneousInvoices/" +
                                      option.invoice_id
                                    )
                                  }
                                />
                              )}

                              <SearchIcon
                                className="editBt"
                                onClick={() =>
                                  navigate(
                                    "/MiscellaneousInvoicesPreview/" +
                                    option.invoice_id
                                  )
                                }
                              />
                              {option.is_paid ? (
                                <div>
                                  <Button
                                    className="paidBtn"
                                    onClick={handleClickOpen(
                                      "body",
                                      option,
                                      "edit"
                                    )}
                                  >
                                    Mark As UnPaid
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  className="paidBtn"
                                  onClick={handleClickOpen(
                                    "body",
                                    option,
                                    "add"
                                  )}
                                >
                                  Pay Now
                                </Button>
                              )}
                            </div>
                          </div>

                          {option.paid_note ? (
                            <div className="noteTop">
                              <h3 className="visitContHed">Note :</h3>
                              <i>
                                <p className="visitContMob">
                                  {option.paid_note}
                                </p>
                              </i>
                              <p className="visitContMob">
                                {" "}
                                <span>(</span>
                                {moment(option.note_added_time).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                {moment(option.note_added_time).format(
                                  "hh:mm:ss A"
                                )}
                                <span>)</span>
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      ))}
                    </div>
                  </TabPanel>
                </Box>

                <Grid container spacing={3}>
                  <Grid item xs={12} md={12} className="newPagiMai">
                    <Pagination
                      count={Math.ceil(totalItems / itemsPerPage)}
                      page={currentPage}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded"
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            {isPaid ? (
              <span>Mark It As Unpaid</span>
            ) : (
              <span>Mark It As Paid</span>
            )}

            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  {isPaid ? (
                    <Grid item xs={12} md={12}>
                      <textarea
                        className="textAriaSt"
                        placeholder="Add A Note"
                        onChangeCapture={(e) => setPaidNote(e.target.value)}
                        value={paid_note}
                      ></textarea>
                    </Grid>
                  ) : (
                    <Grid item xs={12} md={12}>
                      <textarea
                        className="textAriaSt"
                        placeholder="Add A Note"
                        onChangeCapture={(e) => setPaidNote(e.target.value)}
                      ></textarea>
                    </Grid>
                  )}
                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button
                        className="modalMainBt"
                        onClick={() => paidInvoice()}
                      >
                        {isPaid ? (
                          <div>MARK AS UNPAID</div>
                        ) : (
                          <div>MARK AS PAID</div>
                        )}
                      </Button>
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                      <h4>Success !</h4>
                      {isPaid ? (
                        <p>Invoice Unpaid successfully</p>
                      ) : (
                        <p>Invoice Paid successfully</p>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default CreateInvoiceNewList;
